import register from "preact-custom-element";
import ProductNotifyMe from "./components/product-notify-me";

// Check if the custom element is already registered
if (!customElements.get("uwp-product-notify-me")) {
  register(ProductNotifyMe, "uwp-product-notify-me", [
    "is-visible",
    "variant-id",
  ]);
}
